import React, { useEffect, useState } from 'react'
import '../../Assets/CSS/Annexures.css'
import { Icon } from "@iconify/react";
import axios from 'axios';
import toast from 'react-hot-toast';

const Annexures = () => {



  const [formData, setFormData] = useState({
    annexureName: "",
    annexureDesc: ""
  });
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    // Remove validation error immediately
    setErrors({ ...errors, [e.target.name]: "" });
  };


  const validate = () => {
    let newErrors = {};

    if (!formData.annexureName.trim())
      newErrors.annexureName = "Annexure Name is required";

    if (!formData.annexureDesc.trim())
      newErrors.annexureDesc = "Annexure Description is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [list, setList] = useState([]);

  const [openId, setOpenId] = useState(null);
  const [errors, setErrors] = useState({
    name: "",
    desc: ""
  });

   // ✅ Fetch Annexure List From API
  useEffect(() => {
    fetchAnnexures();
  }, []);

  //get Api

  const fetchAnnexures = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/annexures`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        }
      );

      console.log("GET SUCCESS:", response.data);

      // ⭐ Mapping API Response → Your UI Structure
      const formattedList = response.data.map(item => ({
        id: item.id,
        name: item.heading,
        description: item.description,
        date: item.createdAt?.split("T")[0] // yyyy-mm-dd
      }));

      setList(formattedList);

    } catch (error) {
      console.error("GET ERROR:", error);
    }
  };


  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

//post Api

  const handleAdd = async () => {
    if (!validate()) return;
    const token = localStorage.getItem("token")

    const payload = {
      heading: formData.annexureName,
      description: formData.annexureDesc
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/annexures`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",

            Authorization: `Bearer ${token}`,
          }
        }
      );

      console.log("API SUCCESS:", response.data);



      setList([...list]);

      // Reset Form
      setFormData({ annexureName: "", annexureDesc: "" });
      setErrors({});

     
      toast.success("Annexure Added Successfully!")
    } catch (error) {
      console.error("API ERROR:", error);
      toast.error("Failed to add annexure");
    }
  };
const openDeleteModal = (id) => {
  setDeleteId(id);
  setShowDeleteModal(true);
};

const closeDeleteModal = () => {
  setDeleteId(null);
  setShowDeleteModal(false);
};



  const confirmDelete = async () => {
  const token = localStorage.getItem("token");

  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/annexures/${deleteId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Remove from UI
    setList(list.filter(item => item.id !== deleteId));

    toast.success("Annexure deleted successfully");
    closeDeleteModal();
  } catch (error) {
    console.error("DELETE ERROR:", error);
    toast.error("Failed to delete annexure");
  }
};




  return (
    <div className=''>
      <div className='backgrond-color p-4'>
        <p className='fs'>Create New Annexure</p>
        {/* Annexure Name */}
        <div className="mb-3">
          <input

            type="text"
            name="annexureName"
            className="form-control"
            placeholder="Annexure Name"
            value={formData.annexureName}
            onChange={handleChange}

            style={{
              borderRadius: '8px', border: '1px solid #C8C8C8'

              ,
              color: '#606060'
            }} // blue border
          />{errors.annexureName && <p style={{ color: "red", fontSize: "12px" }}>{errors.annexureName}</p>}
        </div>
        {/* Annexure Description */}
        <div className="mb-3">
          <textarea
            name="annexureDesc"
            className="form-control"
            placeholder="Annexure Description*"
            rows="4"
            value={formData.annexureDesc}
            onChange={handleChange}
            style={{
              height: '70px', borderRadius: '8px', border: '1px solid #C8C8C8',


              color: '#606060'
            }}
          ></textarea>
          {errors.annexureDesc && <p style={{ color: "red", fontSize: "12px" }}>{errors.annexureDesc}</p>}
        </div>

        {/* Add Button */}
        <button
          onClick={handleAdd}
          className="add-btn"
          style={{
            width: "106px",
            height: "40px",
            fontSize: "14px",
            padding: "0",
            justifyContent: 'center'
            , marginTop: '15px'
          }}
        >
          Add
        </button>
      </div>


      <div style={{ marginTop: "30px" }}>
        <div className="p-3">

          {list.length > 0 && <p>Annexure List</p>}

          {list.map((item) => (
            <div
              key={item.id}
              className="mb-3 p-3 annexelist"
              style={{
                borderRadius: "8px",
                transition: "0.3s",
                cursor: "pointer",
              }}
            >
              {/* TOP ROW */}
              <div
                className="flex-wrap"
                onClick={() => toggleAccordion(item.id)}
              >
                {/* ---------------- MOBILE VIEW ---------------- */}
                <div
                  className="d-flex d-sm-none w-100"
                  style={{
                    alignItems: "flex-start",
                    gap: "8px",
                  }}
                >
                  {/* NAME (WRAPS) */}
                  <p
                    style={{
                      flex: 1,
                      minWidth: 0,
                      margin: 0,
                      fontWeight: 500,
                      fontSize: "14px",
                      wordBreak: "break-word",
                      lineHeight: "18px",
                    }}
                  >
                    {item.name}
                  </p>

                  {/* ARROW - FIXED */}
                  <div style={{ flexShrink: 0 }}>
                    <Icon
                      icon={
                        openId === item.id ? "mdi:chevron-up" : "mdi:chevron-down"
                      }
                      style={{
                        fontSize: "22px",
                        color: "#606060",
                      }}
                    />
                  </div>
                </div>

                {/* MOBILE ROW 2 → DATE + DELETE */}
                <div className="d-flex d-sm-none justify-content-between align-items-center w-100 mt-2">
                  <p style={{ fontSize: "12px", color: "#909090", margin: 0 }}>
                    {item.date}
                  </p>

                  <Icon
  icon="material-symbols:delete-outline"
  style={{ fontSize: "18px", color: "#606060" }}
  onClick={(e) => {
    e.stopPropagation();
    openDeleteModal(item.id); // 👈 open confirmation popup
  }}
/>

                </div>

                {/* ---------------- DESKTOP VIEW ---------------- */}
                <div className="d-none d-sm-flex justify-content-between align-items-center">
                  {/* LEFT NAME */}
                  <p
                    className="m-0"
                    style={{
                      fontWeight: "500",
                      fontSize: "14px",
                    }}
                  >
                    {item.name}
                  </p>

                  {/* RIGHT SIDE: DATE + DELETE + ARROW */}
                  <div className="d-flex align-items-center gap-5">
                    <p style={{ fontSize: "12px", color: "#909090", margin: 0 }}>
                      {item.date}
                    </p>

                    {/* <Icon
                icon="material-symbols:delete-outline"
                style={{ fontSize: "18px", color: "#606060" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(item.id);
                }}
              /> */}
                  <Icon
  icon="material-symbols:delete-outline"
  style={{ fontSize: "18px", color: "#606060" }}
  onClick={(e) => {
    e.stopPropagation();
    openDeleteModal(item.id); // 👈 open confirmation popup
  }}
/>



                    <Icon
                      icon={
                        openId === item.id ? "mdi:chevron-up" : "mdi:chevron-down"
                      }
                      style={{
                        fontSize: "22px",
                        color: "#606060",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* EXPANDED CONTENT */}
              {openId === item.id && (
                <div
                  className="mt-3"
                  style={{
                    borderTop: "1px solid #dcdcdc",
                    paddingTop: "10px",
                  }}
                >
                  <p
                    style={{
                      color: "#7a7a7a",
                      fontSize: "12px",
                      margin: 0,
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {item.description}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
{showDeleteModal && (
  <div className="delete-overlay">
    <div className="delete-card">
      
      {/* ICON */}
      <div className="delete-icon-wrapper">
        <Icon
          icon="material-symbols:delete-outline"
          className="delete-icon-top"
        />
      </div>

      {/* TITLE */}
      <h3 className="delete-title">Delete Department</h3>

      {/* DESCRIPTION */}
      <p className="delete-desc">
        Are you sure you want to delete this department?
        This action cannot be undone.
      </p>

      {/* ACTIONS */}
      <div className="delete-actions">
        <button
          className="btn-cancel-delete"
          onClick={closeDeleteModal}
        >
          Cancel
        </button>

        <button
          className="btn-confirm-delete"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </div>

    </div>
  </div>
)}


      


    </div>
  )
}

export default Annexures